import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import styles from './LandscapeCommoditiesEditTemplate.module.css';
import cn from 'classnames';
import { Label } from '../../atoms';
import { Button, Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LandscapeCommodityResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-commodity-response.dto';
import { CommoditiesEditChooseOrganism } from '../../organisms';

export interface LandscapeCommoditiesEditTemplateProps {
  commodityLandscape: LandscapeCommodityResponseDto;
  handleOnChange: (commodity: LandscapeCommodityResponseDto) => void;
  callbackFn: (commodityLandscape: LandscapeCommodityResponseDto) => void;
}

const LandscapeCommoditiesEditTemplate: FC<
  LandscapeCommoditiesEditTemplateProps
> = ({ commodityLandscape, handleOnChange, callbackFn }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Choose Commodity" size="lg" />
          <Button
            className={styles.buttonLink}
            onClick={() => navigate(`/landscapes/edit/${id}/commodities`)}
            variant="link"
          >
            Go back to overview
          </Button>
        </div>

        <div className={cn(styles.commoditiesChooseOrganismWrapper)}>
          <CommoditiesEditChooseOrganism
            commodityLandscape={commodityLandscape}
            handleOnChange={handleOnChange}
            callbackFn={callbackFn}
          />
        </div>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeCommoditiesEditTemplate;
